import {
  Box,
  Container,
  Stack,
  Typography,
  BottomNavigationAction,
  BottomNavigation,
} from "@mui/material";
import GlobalHeader from "../../../components/GlobalHeader";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import useApi from "../../../hooks/useApi";
import { useEffect, useState } from "react";
import { FaUsers } from "react-icons/fa";
import { GiLoveSong, GiGuitarBassHead } from "react-icons/gi";
import { BsCashStack } from "react-icons/bs";
import { ImFileExcel } from "react-icons/im";
import RestoreIcon from "@mui/icons-material/Restore";

ChartJS.register(ArcElement, Tooltip, Legend);

const Dashboard = () => {
  const { loadApi } = useApi([]);
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);

  const [musicos, setMusicos] = useState({});
  const [productoresNuevos, setProductoresNuevos] = useState({});
  const [canciones, setCanciones] = useState({});
  const [cancionesR, setCancionesR] = useState({});
  const [compras, setCompras] = useState({});
  const [productores, setProductores] = useState({});
  const [artistas, setArtistas] = useState({});

  const [chartO, setChartO] = useState({
    labels: [],
    datasets: [
      {
        label: "Envíos totales",
        data: [],
        backgroundColor: ["#F27224", "#F2C324", "#245DF2", "#24F2C3", "#F2245D"],
        borderColor: "white",
        borderWidth: 1,
      },
    ],
  });

  const [chart2, setChart2] = useState({
    labels: [],
    datasets: [
      {
        label: "Envíos totales",
        data: [],
        backgroundColor: ["#F27224", "#F2C324", "#245DF2", "#24F2C3", "#F2245D"],
        borderColor: "white",
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    getMusicosNuevos();
    getProductoresNuevos();
    getCancionesCompartidas();
    getCancionesRechazadas();
    getCompras();
    getTopArtistas();
    getTopProductores();
  }, []);

  const descargarReporte = () => {
    loadApi("admin/stats/downloadReportA", true, "get", undefined, false, true)
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
  };

  const getMusicosNuevos = () => {
    loadApi("admin/stats/musicos", true, "get").then((res) => {
      setMusicos(res.data || {});
    });
  };

  const getProductoresNuevos = () => {
    loadApi("admin/stats/productores", true, "get").then((res) => {
      setProductoresNuevos(res.data || {});
    });
  };

  const getCancionesCompartidas = () => {
    loadApi("admin/stats/canciones_compartidas", true, "get").then((res) => {
      setCanciones(res.data || {});
    });
  };

  const getCancionesRechazadas = () => {
    loadApi("admin/stats/canciones_rechazadas", true, "get").then((res) => {
      setCancionesR(res.data || {});
    });
  };

  const getCompras = () => {
    loadApi("admin/stats/compras_creditos", true, "get").then((res) => {
      setCompras(res.data || {});
    });
  };

  const getTopProductores = () => {
    loadApi("admin/stats/productores_activos", true, "get").then((res) => {
      const data = res.data || {};
      const productoresDia = data.productores_activos_dia || [];
      setProductores(data);

      const arrayNames = productoresDia.map((item) => item.name);
      const arrayValues = productoresDia.map((item) => Number(item.envios));

      if (arrayNames.length > 0 && arrayValues.length > 0) {
        setChart2((prev) => ({
          ...prev,
          labels: arrayNames,
          datasets: [{ ...prev.datasets[0], data: arrayValues }],
        }));
      } else {
        setChart2((prev) => ({
          ...prev,
          labels: [],
          datasets: [{ ...prev.datasets[0], data: [] }],
        }));
      }
    });
  };

  const getTopArtistas = () => {
    loadApi("admin/stats/artistas_activos", true, "get").then((res) => {
      const data = res.data || {};
      const artistasDia = data.artistas_activos_dia || [];
      setArtistas(data);

      const arrayNames = artistasDia.map((item) => item.name);
      const arrayValues = artistasDia.map((item) => Number(item.envios));

      if (arrayNames.length > 0 && arrayValues.length > 0) {
        setChartO((prev) => ({
          ...prev,
          labels: arrayNames,
          datasets: [{ ...prev.datasets[0], data: arrayValues }],
        }));
      } else {
        setChartO((prev) => ({
          ...prev,
          labels: [],
          datasets: [{ ...prev.datasets[0], data: [] }],
        }));
      }
    });
  };

  const handleChangeTimeArtist = (newValue) => {
    let arraynew = [];

    if (newValue === 1) {
      arraynew = artistas.artistas_activos_semana || [];
    } else if (newValue === 2) {
      arraynew = artistas.artistas_activos_mes || [];
    } else {
      arraynew = artistas.artistas_activos_dia || [];
    }

    const arrayNames = arraynew.map((item) => item.name);
    const arrayValues = arraynew.map((item) => Number(item.envios));

    if (arrayNames.length > 0 && arrayValues.length > 0) {
      setChartO((prev) => ({
        ...prev,
        labels: arrayNames,
        datasets: [{ ...prev.datasets[0], data: arrayValues }],
      }));
    } else {
      setChartO((prev) => ({
        ...prev,
        labels: [],
        datasets: [{ ...prev.datasets[0], data: [] }],
      }));
    }
  };

  const handleChangeTimeProducotres = (newValue) => {
    let arraynew = [];

    if (newValue === 1) {
      arraynew = productores.productores_activos_semana || [];
    } else if (newValue === 2) {
      arraynew = productores.productores_activos_mes || [];
    } else {
      arraynew = productores.productores_activos_dia || [];
    }

    const arrayNames = arraynew.map((item) => item.name);
    const arrayValues = arraynew.map((item) => Number(item.envios));

    if (arrayNames.length > 0 && arrayValues.length > 0) {
      setChart2((prev) => ({
        ...prev,
        labels: arrayNames,
        datasets: [{ ...prev.datasets[0], data: arrayValues }],
      }));
    } else {
      setChart2((prev) => ({
        ...prev,
        labels: [],
        datasets: [{ ...prev.datasets[0], data: [] }],
      }));
    }
  };

  return (
    <>
      <GlobalHeader />
      <Container>
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          pb={4}
          spacing={1}
        >
          <Stack flexGrow="1" spacing={2}>
            <Stack>
              <Typography>Musicos nuevos</Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  gap: "10px",
                }}
              >
                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <FaUsers />
                  </Typography>
                  <Typography textAlign="center">Nuevos hoy</Typography>
                  <Typography>{musicos.musicos_nuevos_dia || 0}</Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <FaUsers />
                  </Typography>
                  <Typography textAlign="center">Nuevos esta semana</Typography>
                  <Typography>{musicos.musicos_nuevos_semana || 0}</Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <FaUsers />
                  </Typography>
                  <Typography textAlign="center">Nuevos este mes</Typography>
                  <Typography>{musicos.musicos_nuevos_mes || 0}</Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack>
              <Typography>Difusores nuevos</Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  gap: "10px",
                }}
              >
                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <FaUsers />
                  </Typography>
                  <Typography textAlign="center">Nuevos hoy</Typography>
                  <Typography>
                    {productoresNuevos.productores_nuevos_dia || 0}
                  </Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <FaUsers />
                  </Typography>
                  <Typography textAlign="center">Nuevos esta semana</Typography>
                  <Typography>
                    {productoresNuevos.productores_nuevos_semana || 0}
                  </Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <FaUsers />
                  </Typography>
                  <Typography textAlign="center">Nuevos este mes</Typography>
                  <Typography>
                    {productoresNuevos.productores_nuevos_mes || 0}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack>
              <Typography>Canciones compartidas</Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  gap: "10px",
                }}
              >
                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <GiLoveSong />
                  </Typography>
                  <Typography textAlign="center">Canciones hoy</Typography>
                  <Typography>
                    {canciones.canciones_compartidas_dia || 0}
                  </Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <GiLoveSong />
                  </Typography>
                  <Typography textAlign="center">
                    Canciones esta semana
                  </Typography>
                  <Typography>
                    {canciones.canciones_compartidas_semana || 0}
                  </Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <GiLoveSong />
                  </Typography>
                  <Typography textAlign="center">Canciones este mes</Typography>
                  <Typography>
                    {canciones.canciones_compartidas_mes || 0}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack>
              <Typography>Canciones rechazadas</Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  gap: "10px",
                }}
              >
                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <GiGuitarBassHead />
                  </Typography>
                  <Typography textAlign="center">Canciones hoy</Typography>
                  <Typography>
                    {cancionesR.canciones_rechazadas_dia || 0}
                  </Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <GiGuitarBassHead />
                  </Typography>
                  <Typography textAlign="center">
                    Canciones esta semana
                  </Typography>
                  <Typography>
                    {cancionesR.canciones_rechazadas_semana || 0}
                  </Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <GiGuitarBassHead />
                  </Typography>
                  <Typography textAlign="center">Canciones este mes</Typography>
                  <Typography>
                    {cancionesR.canciones_rechazadas_mes || 0}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack>
              <Typography>Total compras (USD)</Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  gap: "10px",
                }}
              >
                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <BsCashStack />
                  </Typography>
                  <Typography textAlign="center">Créditos hoy</Typography>
                  <Typography>{compras.compra_dia || 0} USD</Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <BsCashStack />
                  </Typography>
                  <Typography textAlign="center">
                    Créditos esta semana
                  </Typography>
                  <Typography>{compras.compra_semana || 0} USD</Typography>
                </Stack>

                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Typography fontSize="26px">
                    <BsCashStack />
                  </Typography>
                  <Typography textAlign="center">Créditos este mes</Typography>
                  <Typography>{compras.compra_mes || 0} USD</Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack>
              <Typography>Reporte</Typography>
              <Stack
                sx={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  gap: "10px",
                }}
              >
                <Stack
                  alignItems="center"
                  py="10px"
                  px="20px"
                  borderRadius="10px"
                  backgroundColor="#f1f1f1"
                >
                  <Box maxWidth="25px" width="100%">
                    <BottomNavigation
                      showLabels
                      onChange={() => {
                        descargarReporte();
                      }}
                    >
                      <BottomNavigationAction
                        icon={<ImFileExcel size={25} />}
                      />
                    </BottomNavigation>
                  </Box>
                  <Typography textAlign="center">Descargar reporte</Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack flexGrow="1" alignItems="center">
            <Typography variant="h6" textAlign="center">
              Artistas que enviaron más canciones
            </Typography>

            <Box maxWidth="300px" width="100%">
              <Box>
                <BottomNavigation
                  showLabels
                  value={value}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    handleChangeTimeArtist(newValue);
                  }}
                >
                  <BottomNavigationAction label="Dia" icon={<RestoreIcon />} />
                  <BottomNavigationAction
                    label="Semana"
                    icon={<RestoreIcon />}
                  />
                  <BottomNavigationAction label="Mes" icon={<RestoreIcon />} />
                </BottomNavigation>
              </Box>

              {chartO.labels.length === 0 ? (
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ marginTop: "20px" }}
                >
                  No hay datos disponibles para los artistas.
                </Typography>
              ) : (
                <Doughnut data={chartO} />
              )}
            </Box>

            <Typography variant="h6" textAlign="center" mt={2}>
              Difusores que recibieron más canciones
            </Typography>

            <Box maxWidth="300px" width="100%">
              <Box>
                <BottomNavigation
                  showLabels
                  value={value1}
                  onChange={(event, newValue) => {
                    setValue1(newValue);
                    handleChangeTimeProducotres(newValue);
                  }}
                >
                  <BottomNavigationAction label="Dia" icon={<RestoreIcon />} />
                  <BottomNavigationAction
                    label="Semana"
                    icon={<RestoreIcon />}
                  />
                  <BottomNavigationAction label="Mes" icon={<RestoreIcon />} />
                </BottomNavigation>
              </Box>

              {chart2.labels.length === 0 ? (
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ marginTop: "20px" }}
                >
                  No hay datos disponibles para los difusores.
                </Typography>
              ) : (
                <Doughnut data={chart2} />
              )}
            </Box>
          </Stack>
        </Stack>
      </Container>
    </>
  );
};

export default Dashboard;